/*
Componente tarjeta de regalos/articulos de ilusiona
Informativo
*/

import React from 'react'
import PropTypes from 'prop-types'

// CONSTANTS
import FORMATNUMBER from '../constants'

// #region CSS
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import Grid from '@material-ui/core/Grid'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip'
import Zoom from '@material-ui/core/Zoom'

const FALLBACK_IMAGE = 'data:image/svg+xml;base64,' + btoa('<svg xmlns="http://www.w3.org/2000/svg" width="345" height="200" viewBox="0 0 345 200"><rect fill="#f5f5f5" width="345" height="200"/><text fill="#bdbdbd" font-family="Arial" font-size="14" x="50%" y="50%" text-anchor="middle" dy=".3em">Imagen no disponible</text></svg>')

const useStyles = makeStyles({
  card: {
    width: 345
  },
  media: {
    height: '200px',
    width: '100%',
    objectFit: 'contain'
  },
  titleCard: {
    height: '65px',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical'
  },
  titleCardFideliz: {
    height: '65px',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    fontSize: '1rem'
  },
  tooltip: {
    fontSize: 14,
    color: 'white',
    backgroundColor: '#3a3434',
    fontWeight: 200
  }
})
// #endregion

export default function CardGift({ gift, onClick, options }) {
  const classes = useStyles()
  const [imgError, setImgError] = React.useState(false)

  const isFidelizacion = options ? !!options.isFidelizacion : false
  // Checkeamos si la pantalla tiene esos modulos, para mostrar diferentes estilos
  const haveClient = options ? !!options.haveClient : false
  const haveMovement = options ? !!options.haveMovement : false

  return (
    <Tooltip TransitionComponent={Zoom} placement='top' title={gift.name} classes={{ tooltip: classes.tooltip }}>
      <Card className={classes.card} onClick={() => onClick(gift)}>
        <CardActionArea>
          <CardMedia
            component="img"
            className={classes.media}
            image={imgError || !gift.image ? FALLBACK_IMAGE : gift.image}
            onError={() => setImgError(true)}
          />
          <CardContent>
            <Typography
              gutterBottom
              variant='h5'
              color='primary'
              className={isFidelizacion ? classes.titleCardFideliz : classes.titleCard}
            >
              {gift.name}
            </Typography>
            <Grid container direction='row' alignItems='center'>
              <Grid item xs={isFidelizacion ? (haveClient || haveMovement ? 6 : 12) : 6}>
                <Typography variant='body2' color='secondary' component='p'>
                  <span data-lang-html="gift_points" data-lang-vars={JSON.stringify({points: FORMATNUMBER(gift.points)})}>{FORMATNUMBER(gift.points)} puntos</span>
                </Typography>
              </Grid>
              {options ? (
                options.isFidelizacion ? (
                  <Grid item xs={isFidelizacion ? (haveClient || haveMovement ? 6 : 12) : 6}>
                    <Typography
                      variant='body2'
                      color='secondary'
                      component='p'
                      align={isFidelizacion ? (haveClient || haveMovement ? 'right' : 'left') : 'right'}
                    >
                      <span data-lang-html="gift_stock" data-lang-vars={JSON.stringify({stock: FORMATNUMBER(gift.stock)})}>{FORMATNUMBER(gift.stock)} stock</span>
                    </Typography>
                  </Grid>
                ) : null
              ) : null}
            </Grid>
          </CardContent>
        </CardActionArea>
      </Card>
    </Tooltip>
  )
}

CardGift.propTypes = {
  gift: PropTypes.shape({
    name: PropTypes.string,
    image: PropTypes.string,
    points: PropTypes.number,
    stock: PropTypes.number
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  options: PropTypes.object
}
